import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";
 
import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import {Dimmer} from "../components/spinner";


const CatalogoSPagoNomiAprob = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'CONCEPTO', textAlign: 'center' },
        { label: 'FECHA', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idsolicitudpagonomina.includes(target.value)
                            || x.concepto.toLowerCase().includes(target.value.toLowerCase())
                            || moment.utc(x.fechainicio).format('DD/MM/YYYY').includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarSolicitudesPago = () => {

        let estatus = props.status;

        let endpoint = `${op.conexion}/api/catalogo/pagosnominaaprob?idefiscal=${idefiscal}&status=${estatus}`;
    
        setActivate(true);
    
        axios.get(endpoint,{
            headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }
          }).then(function (response) {
    
          if (response.status === 200) {

            setActivate(false);
            var data = []
            for (let i = 0; i < response.data.length; i++) {
                data.push({
                    idsolicitudpagonomina: response.data[i].idsolicitudpagonomina,
                    concepto: response.data[i].concepto,
                    fechainicio: response.data[i].fechainicio,
                })
            }
            setRecords(data)   
          }  

    
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    
      }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectSolicitud = () => {

        var idsolicitudpagonomina = values[0].idsolicitudpagonomina;
        var concepto = values[0].concepto;
        var fechainicio = values[0].fechainicio;

        blanquear();
        props.onHideAceptaSolicitudes(idsolicitudpagonomina, concepto, fechainicio);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var idsolicitudpagonomina = recordsAfterPagingAndSorting()[index].idsolicitudpagonomina;
        var concepto = recordsAfterPagingAndSorting()[index].concepto;
        var fechainicio = recordsAfterPagingAndSorting()[index].fechainicio;

        var datos = [];
        datos.push({
            idsolicitudpagonomina,
            concepto,
            fechainicio,
        })
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarSolicitudesPago()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>Seleccionar Solicitudes de Pago de Nomina</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.idsolicitudpagonomina}</td>
                                        <td className='py-2 text-start' style={{ width: '250px' }}>{item.concepto}</td>
                                        <td className='py-2 text-center' style={{ width: '150px' }}>{moment.utc(item.fechainicio).format('DD/MM/YYYY')}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectSolicitud}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoSPagoNomiAprob;